import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Redirect_tsk_details() {
   const navigate = useNavigate();
     
       useEffect(() => {
         navigate('/task_details'); 
       }, [navigate]); 
     
       return null; 
}
